import './styles.scss';
import React, {useState} from 'react';
import ContractsTable from "../../components/specific/Contracts.table/Contracts.table.component";
import {useQuery} from "react-query";
import ContractApi from "../../api/Contract/Contract.api";
import DefaultLoader from "../../components/common/DefaultLoader/DefaultLoader";
import moment from "moment";
import ContractsTotals from "../../components/specific/Contracts.graphs/Contracts.graphs.totals";
import ContractsAnalytics from "../../components/specific/Contracts.analytics/Contracts.analytics.component";

interface Props {
    userId?: number,
}

function ContractReportsContainer({userId}: Props) {
    const [page, setPage] = useState(1);

    const {isLoading, data} = useQuery([
        'dashboardAnalyticsWeeklyContracts',
        userId,
        page,
    ], ContractApi.getWeeklyContracts);

    const {
        isLoading: isLoadingAnalytics,
        data: analyticsData,
        isIdle
    } = useQuery([
        'dashboardfetchWeeklyContractAnalytics',
        userId,
    ], ContractApi.getWeeklyContractAnalytics);

    function onPagination(page: number) {
        setPage(page);
    }

    function renderAnalytics() {
        if (isIdle) {
            return null;
        }
        if (isLoadingAnalytics || !analyticsData) {
            return (
                <div style={{marginBottom: 24}}>
                    <DefaultLoader text='Loading analytics...'/>
                </div>
            )
        } else {
            return (
                <div className='analytics-container'>
                    <ContractsTotals data={analyticsData?.rankedVendors?.data}/>
                    <ContractsAnalytics analytics={analyticsData}/>
                </div>
            );
        }
    }

    function renderContractsTable() {
        if (isLoading || !data?.records) {
            return (
                <div className='default-loader-full'>
                    <DefaultLoader text='Loading contracts...'/>
                </div>
            )
        } else {
            const pagination = {
                onChange: onPagination,
                pageSize: 25,
                total: Math.trunc(data.totalRecords),
                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                current: page,
                position: ['topRight'] as any,
                showSizeChanger: false,
            }
            return (
                <div className='weekly-contract-reports-container-content-table'>
                    <ContractsTable data={data.records} pagination={pagination}/>
                </div>
            )
        }
    }

    function getCurrentWeekDates() {
        let lastWeekFirstDay = moment().subtract(1, 'weeks').startOf('week').format('YYYY-MM-DD')
        let lastWeekLastDay = moment().subtract(1, 'weeks').endOf('week').format('YYYY-MM-DD')

        return `Contracts from ${moment(lastWeekFirstDay).format("MMM DD, YYYY")} to ${moment(lastWeekLastDay).format("MMM DD, YYYY")}`;
    }

    return (
        <div className='weekly-contract-reports-container'>
            <div className='weekly-contract-reports-container-header'>
                <div className='title'>
                    {getCurrentWeekDates()}
                </div>
            </div>
            <div className='weekly-contract-reports-container-content'>
                {renderAnalytics()}
                {renderContractsTable()}
            </div>
        </div>
    )
}

export default ContractReportsContainer;